<mat-card class="flex-col flex">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon">
            @if (lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Abandoned) {
                <mat-icon class="cb-error help-cursor" title="Abandoned" aria-hidden="false"
                    >delete_forever</mat-icon
                >
            }
            @if (
                lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Required &&
                !lotQuoteSearchItem?.requiredOverdue
            ) {
                <mat-icon class="cb-error help-cursor" title="Required" aria-hidden="false"
                    >panorama_fish_eye</mat-icon
                >
            }
            @if (
                lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Required &&
                lotQuoteSearchItem?.requiredOverdue
            ) {
                <mat-icon class="cb-error help-cursor" title="Required Overdue" aria-hidden="false"
                    >error_outline</mat-icon
                >
            }
            @if (lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Pending) {
                <mat-icon class="mat-accent help-cursor" title="Pending" aria-hidden="false"
                    >timelapse</mat-icon
                >
            }
            @if (lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Submitted) {
                <mat-icon class="mat-accent help-cursor" title="Submitted" aria-hidden="false"
                    >assignment</mat-icon
                >
            }
            @if (lotQuoteSearchItem?.quoteStatus == QUOTE_STATUS_ENUM.Accepted) {
                <mat-icon class="mat-primary help-cursor" title="Accepted" aria-hidden="false"
                    >assignment_turned_in</mat-icon
                >
            }
        </div>
        <mat-card-title
            >{{
                lotQuoteSearchItem?.supplierTradingName || lotQuoteSearchItem?.freeTextSupplierName
            }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="flex-col cb-margin-bottom">
        @if (lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Required) {
            <cb-display-value-new
                label="Date"
                [value]="lotQuoteSearchItem?.quoteDate | date: 'dd MMM yyyy' | cbDasher"
            >
            </cb-display-value-new>
        }
        <div class="flex-row">
            @if (lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Required) {
                <cb-display-value-new
                    class="flex"
                    label="Required By"
                    [value]="lotQuoteSearchItem?.requiredDate | date: 'dd MMM yyyy' | cbDasher"
                >
                </cb-display-value-new>
            }
            @if (lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Required) {
                <cb-display-value-new class="flex" label="Quote No"
                    >#{{ lotQuoteSearchItem?.quoteNumber }}</cb-display-value-new
                >
            }
            @if (lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Required) {
                <cb-display-value-new class="flex" label="Amount (GST Exclusive)">{{
                    lotQuoteSearchItem?.quoteTotal | cbCurrency
                }}</cb-display-value-new>
            }
        </div>
        <cb-display-value-new
            label="Description"
            [value]="lotQuoteSearchItem?.description"
        ></cb-display-value-new>
        @if (lotQuoteSearchItem?.expiryDate != undefined) {
            <cb-display-value-new class="flex" label="Expiry Date">
                <div class="start-center">
                    @if (
                        hasExpired() &&
                        lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Submitted &&
                        lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Accepted &&
                        lotQuoteSearchItem?.quoteStatus !== QUOTE_STATUS_ENUM.Abandoned
                    ) {
                        <mat-icon class="cb-error help-cursor" title="Expired" aria-hidden="false"
                            >date_range</mat-icon
                        >
                    }
                    <span class="mat-body-2"
                        >&nbsp;{{ lotQuoteSearchItem?.expiryDate | date: 'dd MMM yyyy' | cbDasher }}
                    </span>
                </div>
            </cb-display-value-new>
        }
        @if (lotQuoteSearchItem.isWaitingForChangesToProcess) {
            <cb-info-message
                message="Waiting for Changes to process"
                icon="warning"
                iconClass="mat-warn"
            >
            </cb-info-message>
        }
    </mat-card-content>
    <mat-divider class="card-divider"></mat-divider>
    <mat-card-actions class="flex-col">
        <div class="flex-row flex layoutGap-5">
            @if (canDownload()) {
                <button mat-flat-button (click)="downloadQuote()">
                    <mat-icon>file_download</mat-icon>
                    Download
                </button>
            }
            <span class="flex"></span>
            @if (lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Accepted) {
                <button mat-stroked-button class="no-wrap" (click)="viewQuoteVO()" color="accent">
                    View VO
                </button>
            }
            @if (canAbandonQuote()) {
                <button mat-flat-button (click)="abandonQuote()">Abandon</button>
            }
            @if (
                lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Pending && canManageQuote()
            ) {
                <button mat-stroked-button color="accent" (click)="manageQuote()">Manage</button>
            }
            @if (lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Pending && canEditQuote()) {
                <button mat-stroked-button (click)="editQuote()" color="accent">Edit</button>
            }
            @if (
                lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Required && canCreateQuote()
            ) {
                <button mat-stroked-button (click)="receiveQuote()" color="accent">Receive</button>
            }
            @if (
                lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Accepted ||
                lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Submitted ||
                lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Abandoned
            ) {
                <button mat-stroked-button color="accent" (click)="manageQuote()">View</button>
            }
            @if (lotQuoteSearchItem?.quoteStatus === QUOTE_STATUS_ENUM.Accepted) {
                <button (click)="duplicateQuote()" mat-flat-button>Duplicate</button>
            }
        </div>
    </mat-card-actions>
</mat-card>
